import DialogBuddyInsurance from "./DialogBuddyInsurance";

export default {
    name     : 'dialog_buddy_insurance',
    component: DialogBuddyInsurance,
    dialog   : {
        'max-width': "800px",
        'persistent': true
    }
}
